import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Power.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "PowerIcon";
const n = e;
export {
  n as Power,
  e as PowerIcon
};
